import { Menu } from '@base-ui/react/menu'
import { twMerge } from 'tailwind-merge'
import { listGroupLabel } from '../../../lib/list-styles'
import type { PartProps } from '../../../lib/part-props'

interface MenuGroupLabelProps extends PartProps<Menu.GroupLabel.Props> {
  className?: string
}

function MenuGroupLabel({ className, children, ...props }: MenuGroupLabelProps) {
  return (
    <Menu.GroupLabel className={twMerge(listGroupLabel, className)} {...props}>
      {children}
    </Menu.GroupLabel>
  )
}

export { MenuGroupLabel }
